var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2991 6.91302C69.2635 9.39858 67.9377 11.7527 66.3492 13.9261C62.8815 10.4402 58.7562 7.67917 54.2131 5.80353C49.67 3.92789 44.7998 2.97508 39.8856 3.0005C34.9714 3.02591 30.1112 4.02905 25.5877 5.95159C21.0642 7.87412 16.9676 10.6777 13.5361 14.1993C10.1046 17.7209 7.40667 21.8903 5.59913 26.465C3.79159 31.0398 2.91053 35.9286 3.00717 40.8472C3.10381 45.7659 4.17623 50.6162 6.16208 55.1163C8.14792 59.6163 11.0076 63.6762 14.5748 67.06L15.9449 68.2709C21.1735 72.6813 27.5189 75.5578 34.2792 76.5822C41.0395 77.6065 47.951 76.7387 54.2492 74.0749C60.5474 71.411 65.9867 67.0549 69.9654 61.4885C73.9441 55.922 76.307 49.3623 76.7928 42.5349C77.8037 33.0862 75.0322 21.1278 70.3002 6.91417L70.2991 6.91302ZM19.8486 67.2752C19.454 67.7632 18.9237 68.1231 18.3248 68.3093C17.7259 68.4956 17.0853 68.4998 16.4839 68.3215C15.8826 68.1432 15.3476 67.7903 14.9467 67.3075C14.5458 66.8247 14.2969 66.2337 14.2316 65.6093C14.1662 64.9849 14.2874 64.3551 14.5797 63.7997C14.872 63.2442 15.3223 62.788 15.8737 62.4888C16.425 62.1896 17.0526 62.0608 17.6771 62.1188C18.3016 62.1768 18.8948 62.4189 19.3818 62.8145C20.0341 63.3443 20.4497 64.1118 20.5372 64.9481C20.6247 65.7845 20.377 66.6215 19.8486 67.2752ZM70.1466 56.161C60.9968 68.3623 41.4613 64.2451 28.9359 64.8372C28.9359 64.8372 26.7155 64.9679 24.48 65.3345C24.48 65.3345 25.3234 64.976 26.4012 64.5677C35.1974 61.503 39.3552 60.9131 44.6983 58.1606C54.7584 53.0407 64.7099 41.8283 66.7778 30.1729C62.9504 41.3853 51.3284 51.0272 40.7496 54.9432C33.4992 57.6182 20.4008 60.2239 20.4008 60.2239L19.8728 59.9405C10.9611 55.6036 10.6861 36.2816 26.8934 30.0503C33.9902 27.314 40.7797 28.8163 48.4437 26.9855C56.6276 25.0391 66.0962 18.9015 69.949 10.8914C74.2582 23.7057 79.4499 43.762 70.1408 56.1691L70.1466 56.161Z",
    fill: "#68BD45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/Spring.75c5f65597750b5acc4e9c79db58d0ec.svg";
export { ForwardRef as ReactComponent };